import { useState } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const [light, setLight] = useState(() => document.documentElement.classList.contains("light"));

  const toggle = () => {
    const next = !light;
    setLight(next);
    document.documentElement.classList.toggle("light", next);
    localStorage.setItem("wealthoo_theme", next ? "light" : "dark");
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={light ? "Switch to night" : "Switch to white"}
      className="h-9 w-9 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary row-hover border border-border"
    >
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
}
